import { Layout } from 'components/missed-deal-feedback/components/layout';
import { MissedDealFeedbackReadonlyForm } from 'components/missed-deal-feedback/components/readonly-form';
import { SubmissionStatus } from 'components/missed-deal-feedback/components/submission-status';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { FormattedMessage } from 'react-intl';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { FormIdProps } from 'shared/props';
import { missedDealFeedbackSubmissionRequestDiscarded } from 'state/missed-deal-feeedback/actions';
import { missedDealFeedbackSubmissionRequestConfirmedThunk } from 'state/missed-deal-feeedback/thunk';
export function MissedDealFeedbackSubmissionRequestedForm({ formId }: FormIdProps) {
  return (
    <Layout.Wrapper>
      <Layout.Body>
        <MissedDealFeedbackReadonlyForm formId={formId} />
      </Layout.Body>
      <MissedDealFeedbackSubmissionConfirmation formId={formId} />
    </Layout.Wrapper>
  );
}

export function MissedDealFeedbackSubmissionConfirmation({ formId }: FormIdProps) {
  const dispatch = useThunkDispatch();
  return (
    <>
      <SubmissionStatus color="info" iconName="info_outline" textIntlKey="missedDealFeedback.confirm">
        <button
          className="btn btn-primary-alt text-primary ms-3"
          data-e2e="missedDealFeedback-confirm-yes-button"
          onClick={() => {
            dispatch(missedDealFeedbackSubmissionRequestConfirmedThunk(formId));
            logAnalytics.trackEvent('Missed Deal Feedback', 'Confirm the submission');
          }}
        >
          <FormattedMessage id="form.Yes" />
        </button>
        <button
          className="btn btn-discreet-primary text-primary-alt "
          data-e2e="missedDealFeedback-confirm-no-button"
          onClick={() => {
            dispatch(missedDealFeedbackSubmissionRequestDiscarded(formId));
            logAnalytics.trackEvent('Missed Deal Feedback', 'Decline the submission');
          }}
        >
          <FormattedMessage id="form.No" />
        </button>
      </SubmissionStatus>
    </>
  );
}
